import { useLocation } from "react-router-dom";

export const useCanonicalUrl = (allowedParams = []) => {
  const location = useLocation();

  // Filter query parameters if needed
  const rawParams = new URLSearchParams(location.search);
  const filteredParams = new URLSearchParams();

  allowedParams.forEach((param) => {
    const value = rawParams.get(param);
    if (value) filteredParams.set(param, value);
  });

  const paramString = filteredParams.toString();
  const origin = window.location.origin; // gets current domain

  const canonicalUrl = `${origin}${location.pathname}${
    paramString ? `?${paramString}` : ""
  }`;
  return canonicalUrl;
};
